<template>
  <div class="data-slot">
    <div>
      <div class="decription-data display-title">{{text}}</div>
    </div>
    <div>
      <div class="value-data display-title">{{value}}</div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'DocumentStatCard',
  props: ['text', 'value'],
}
</script>

<style type="css" scoped>
.data-slot {
  background-color: white;
  max-width: 15rem;
  border-radius: 5px;
  overflow: hidden;
  margin: 1rem;
}
.data-slot > div:nth-child(1) {
  height: 7rem;
  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.data-slot > div:nth-child(2) {
  color: white;
  padding: 1rem 0 0.5rem 0;
  background-color: var(--a-dark-blue);
}

.value-data {
  font-size: 1.75rem;
}

.decription-data {
  font-size: 1.5rem;
}

.display-title {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  display: block;
}

@media screen and (min-width: 1920px) {
  .data-slot {
    min-width: 20rem;
  }

  .data-slot > div:nth-child(1) {
    height: 7rem;
    padding: 2rem;
  }

  .value-data {
    font-size: 1.75rem;
  }

  .decription-data {
    font-size: 1.85rem;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/document/DocumentsStatCard.vue